import { QueryList } from '@angular/core';

import { TableRowSelectorDirective } from 'remarketing-ui-components-lib';

import { AnalyticsService } from 'smartauction-frontend-micro-library';

export function toggleDrawer(
  drawers: QueryList<TableRowSelectorDirective>,
  index: number,
  analyticsService: AnalyticsService
): void {
  const drawer = drawers.toArray()[index * 2 + 1];
  if (drawer.isOpen) {
    drawer.close();
  } else {
    drawer.open();
  }

  analyticsService.track('clickEvent', {
    tagName: 'BUTTON',
    allytmln: 'Ambassador Name',
    linkName: 'Ambassador Name (button)',
    href: 'javascript:void(0);'
  });
}

export function closeDrawer(
  drawers: QueryList<TableRowSelectorDirective>,
  index: number
): void {
  const drawer = drawers.toArray()[index * 2 + 1];
  drawer.close();
}
